//  Applica al body una classe CSS custom
import React, { Component } from "react";
import {PropTypes} from 'prop-types';

class BodyStyle extends Component {
  constructor( props ){
    super();
  }
  componentWillMount(){
    if(this.props.customClass && !document.body.classList.contains(this.props.customClass) ) {
      document.body.classList.add(this.props.customClass);
    }
  }

  render(){
    return null;
  }
}

BodyStyle.propTypes = {
  customClass: PropTypes.string.isRequired
};

export default BodyStyle;